import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Gavel, CheckCircle, Warning, Hourglass } from '@phosphor-icons/react';
import { API } from '@/App';

const STATUS_STYLE = {
  open: 'bg-yellow-100 text-yellow-700',
  under_review: 'bg-blue-100 text-blue-700',
  awaiting_evidence: 'bg-amber-100 text-amber-700',
  resolved: 'bg-green-100 text-green-700',
  closed: 'bg-gray-100 text-gray-600',
};

const AdminDisputes = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/disputes`, { credentials: 'include' })
      .then((r) => r.json()).then((d) => { setRows(d.disputes || []); setLoading(false); });
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900 mb-1" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }} data-testid="admin-disputes-title">
        Disputes
      </h1>
      <p className="text-sm text-gray-500 mb-8">Review evidence, decide refund / release / partial / escalate.</p>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr className="text-left text-xs uppercase tracking-wider text-gray-500">
              <th className="px-4 py-3">Dispute</th>
              <th className="px-4 py-3">Booking</th>
              <th className="px-4 py-3">Reason</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Opened</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody data-testid="disputes-table">
            {loading && <tr><td colSpan="6" className="px-4 py-8 text-center text-gray-400">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan="6" className="px-4 py-12 text-center text-gray-400">
              <Gavel size={36} weight="duotone" className="mx-auto mb-2 text-gray-300" /> No disputes — nice and quiet.
            </td></tr>}
            {rows.map((d) => (
              <tr key={d.dispute_id} className="border-t border-gray-100" data-testid={`dispute-row-${d.dispute_id}`}>
                <td className="px-4 py-3 font-mono text-[11px] text-gray-600">{d.dispute_id}</td>
                <td className="px-4 py-3 font-mono text-[11px] text-gray-600">{d.booking_id}</td>
                <td className="px-4 py-3 max-w-xs truncate" title={d.reason}>{d.reason}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${STATUS_STYLE[d.status] || 'bg-gray-100 text-gray-600'}`}>
                    {d.status?.replace(/_/g, ' ')}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-gray-500">{new Date(d.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 text-right">
                  <Link to={`/admin/disputes/${d.dispute_id}`} className="text-[#6D28D9] hover:underline font-semibold" data-testid={`view-${d.dispute_id}`}>
                    Review →
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDisputes;
